// Imports
import Vue from 'vue'
import Router from 'vue-router'

import {
  layout,
  route,
} from '@/util/routes'

// Multiverse settings
import Infinity from '@/views/infinity/Settings'
import Registries from '@/views/infinity/Registries'
import Repositories from '@/views/infinity/Repositories'
import Secrets from '@/views/infinity/Secrets'
import StorageClasses from '@/views/infinity/StorageClasses'
import Users from '@/views/infinity/Users'

// Universe settings
import Universe from '@/views/universe/Settings'
import UniverseSecrets from '@/views/universe/Secrets'
import Storages from '@/views/universe/Storages'
import UniverseUsers from '@/views/universe/Users'
import CreateUniverse from '@/views/universe/CreateUniverse'

// App routes
import CreateApp from '@/views/app/CreateApp'
import AppControl from '@/views/app/Control'
import AppSettings from '@/views/app/Settings'
import AppUsers from '@/views/app/Users'
import AppVisitors from '@/views/app/Visitors'
import LogBook from '@/views/app/LogBook'

// Dev routes
import DeveloperSettings from '@/views/developer/Settings'
import DeveloperSecrets from '@/views/developer/Secrets'
import DeveloperStorages from '@/views/developer/Storages'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash }
    if (savedPosition) return savedPosition

    return { x: 0, y: 0 }
  },
  routes: [
    // Multiverse Routes
    { path: '/ui/infinity/settings', component: Infinity, name: 'Infinity' },
    { path: '/ui/infinity/registries', component: Registries, name: 'Registries' },
    { path: '/ui/infinity/repositories', component: Repositories, name: 'Repositories' },
    { path: '/ui/infinity/secrets', component: Secrets, name: 'Secrets' },
    { path: '/ui/infinity/storageclasses', component: StorageClasses, name: 'Storageclasses' },
    { path: '/ui/infinity/users', component: Users, name: 'Users' },

    // Universe Routes
    { path: '/ui/universes/create', component: CreateUniverse, name: 'CreateUniverse' },
    { path: '/ui/universe/:universe/settings', component: Universe, name: 'Universe' },
    { path: '/ui/universe/:universe/secrets', component: UniverseSecrets, name: 'UniverseSecrets' },
    { path: '/ui/universe/:universe/storages', component: Storages, name: 'UniverseStorages' },
    { path: '/ui/universe/:universe/users', component: UniverseUsers, name: 'UniverseUsers' },
    // { path: '/ui/universe/:universe/apps', component: Home, name: 'UniverseApps' },

    // App routes
    { path: '/ui/apps/create', component: CreateApp, name: 'CreateApp' },
    { path: '/ui/universe/:universe/apps/app/:app/control', component: AppControl, name: 'AppControl' },
    { path: '/ui/universe/:universe/apps/app/:app/settings', component: AppSettings, name: 'AppSetttings' },
    { path: '/ui/universe/:universe/apps/app/:app/users', component: AppUsers, name: 'AppUsers' },
    { path: '/ui/universe/:universe/apps/app/:app/visitors', component: AppVisitors, name: 'AppVisitors' },
    { path: '/ui/universe/:universe/apps/app/:app/logbook', component: LogBook, name: 'LogBook' },
    { path: '/ui/universe/:universe/apps/app/:app/logbook/:jobId', component: LogBook, name: 'LogBookId' },

    // Dev routes
    { path: '/ui/developer/settings', component: DeveloperSettings, name: 'DeveloperSettings' },
    { path: '/ui/developer/secrets', component: DeveloperSecrets, name: 'DeveloperSecrets' },
    { path: '/ui/developer/storages', component: DeveloperStorages, name: 'DevelpoerStorages' },

    layout('Default', [      
      route('Home'),
      route('UniverseHome', null, '/ui/universe/:universe/apps'),
      // route('Universes'),
      route('Nodes', null, 'ui/nodes'),

      // Pages
      route('UserProfile', null, 'ui/profile'),
      // Components
      route('Events', null, 'ui/events'),
    ]),
  ],
})

export default router
